import type { TrackingStatus } from '@engine/models/tracking'

interface StatusBadgeProps {
  status?: TrackingStatus
}

const getStatusBadge = (status?: TrackingStatus): string => {
  switch (status) {
    case 'delivered':
      return 'badge-success'
    case 'out-for-delivery':
      return 'badge-info'
    case 'in-transit':
      return 'badge-primary'
    case 'enroute-to-pickup':
      return 'badge-warning'
    case 'error':
    case 'not-found':
      return 'badge-error'
    default:
      return 'badge-base'
  }
}

export const TrackingStatusBadge = ({ status }: StatusBadgeProps) => {
  if (!status) {
    return <span className="badge badge-sm badge-warning">N/A</span>
  }

  return (
    <span className={`badge badge-sm ${getStatusBadge(status)}`}>
      {status.toUpperCase().replace(/-/g, ' ')}
    </span>
  )
}
